import React from 'react';
import CustomBuildsSection from '@/components/CustomBuildsSection';
import SEOHead from '@/components/SEOHead';

// Custom work by the BuildersLab team — a website, app or platform built for
// the customer rather than generated by them. It was the last section of the
// homepage; it has its own page so it can be linked to and found in search.
export default function CustomBuilds() {
  return (
    <div className="pt-20 sm:pt-24">
      <SEOHead
        title="Custom Builds"
        description="Have a big idea? Tell the BuildersLab team about the website, app or platform you need and we'll build it for you. We reply within 24 hours."
        ogUrl="https://builderslab.net/CustomBuilds"
      />
      <CustomBuildsSection />
    </div>
  );
}
